<script>
    import { Router, Link, Route, link, navigate } from "svelte-routing";
    const { jsPDF } = window.jspdf;
    import CardJouet from "../components/cardJouet.svelte"
    import CardModif from "../components/cardJouetModif.svelte"
    import Header from "../components/header.svelte"
    import { isUserDbAdmin} from './stores.js';
    export var db;
    export var auth;
    export let location;
  location = location;

var user = auth.currentUser;
var is_Admin = false;

var  listJouets = [];
var req = false;
var filtre = "owner_name";
var codeVendeur;
var editMode = false
var articlesToPrint = [];
var nbToPrint = 0

var mode = "";
var categorieFilter;

const increment = firebase.firestore.FieldValue.increment(1);
const decrement = firebase.firestore.FieldValue.increment(-1);
function jincremente(a){
  return firebase.firestore.FieldValue.increment(a);
}
function jdecremente(a){
  return firebase.firestore.FieldValue.increment(-a);
}

function goPanier(){
  navigate("/panier", { replace: false });
}
function goClients(){
  navigate("/clients", { replace: false });
}
function goListe(){
  navigate("/user", { replace: false });
}
function goJouets(){
  navigate("/jouets", { replace: false });
}
function goRdv(){
  navigate("/rdv", { replace: false });
}

function logout(){
  auth.signOut().then(() => {
    user = undefined;
    navigate("/", { replace: false });
    window.location.reload()
}).catch((error) => {
  // An error happened.
});
}

function toggleEdit(){
  if(editMode){
    editMode = !editMode
    document.querySelector(".edit").style.background = "#af1d2a"
  }
  else{
    editMode = !editMode
    document.querySelector(".edit").style.background = "#70BB27"
  }
}


function listContains(userList,value){
  for(let i = 0; i<userList.length;i+=1){
      if(userList[i].id == value){
        return true
      }
  }
  return false
}

function listIndex(userList,value){
  for(let i = 0; i<userList.length;i+=1){
      if(userList[i].id == value){
        return i
      }
  }
  return -1
}


function getJouets(value){
  req = false
  listJouets = []
  let listUser = []
  db.collection("jouets").orderBy(value, "asc")
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var temp = doc.data()
          temp.id = doc.id
          listJouets.push(temp)
          if(!listContains(listUser,temp.codeVendeur)){
            let userobj = {}
            userobj.nb = 1
            userobj.id = temp.codeVendeur
            listUser.push(userobj)
          }else{
            listUser[listIndex(listUser,temp.codeVendeur)].nb+=1
          }
        });
        console.log("Nombre total réel : " + listJouets.length);
        console.log("Nombre user total réel : " + listUser.length);
        let sum=0
        listUser.forEach(user => {
          console.log("owner id : "+user.id + " nb : "+user.nb)
          sum += user.nb
        });
        console.log("sum "+sum)
        req = true;
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });
}

function getJouetsUser(value){
  req = false
  listJouets = []
  db.collection("jouets").where("codeVendeur","==",value)
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var temp = doc.data()
          temp.id = doc.id
          listJouets.push(temp)
        });
        mode =""
        req = true;
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });
}

function getJouetsCategorie(){
  req = false
  listJouets = []
  db.collection("jouets").where("categorie","==",categorieFilter)
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          var temp = doc.data()
          temp.id = doc.id
          listJouets.push(temp)
        });
        mode =""
        req = true;
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });
}

var storedUser;

const unsubscribe = isUserDbAdmin.subscribe(value => {
		storedUser = value;
	});


auth.onAuthStateChanged(function(user) {
  if (user) {
    user = auth.currentUser
    if(!storedUser){
          console.log("n'a pas été determiné si admin")
          db.collection("admins").doc(user.uid).get().then((doc) => {
            
            if (doc.exists) {
                  isUserDbAdmin.set({admin:true,name:doc.data().Nom});
                  is_Admin = true
              } else {
                  isUserDbAdmin.set({admin:false})
              }
          }).catch((error) => {
              console.log("Error getting document:", error);
          });;
        }
    if(storedUser.admin == true){
         is_Admin = true
       }


  } else {
    // No user is signed in.
  }
});

    function removeJouet(event){
//verifier la recuperation de l'id dans le jouet mofid puis dans le event dispatcher puis dans la recuperation de l'id dans la finction remove  
var jouet = event.detail.jouet
  console.log(jouet.id)
  let userRef = db.collection('users').doc(jouet.owner_id);
   userRef.update({ nbJouets: decrement,prixTotal: jdecremente(jouet.prix) }).then(()=>{
    db.collection('jouets').doc(jouet.id).delete().then(()=>{
      if(codeVendeur){
        getJouetsUser(jouet.codeVendeur)
      }else{
        getJouets()
      }
      })
   });
}


function resetPrinter(){
  articlesToPrint = []
  nbToPrint = 0
}

function addToPrinter(event){
  articlesToPrint.push(event.detail.jouet)
  nbToPrint+=1
}



/// - - - - - - PDF génération - - - - - - - -

var coordqr = []
var coordname = []
var coordprix = []
var coordrect = []
var coordno = []
var index = 0;

// COORDONNEE POUR LE QR

for(var j = 0;j<4;j++){
  for(var i=0;i<3;i++){
    coordqr.push([i*70+5,j*74+4])
  }
}

// COORDONNEE POUR LE Name

for(var j = 0;j<4;j++){
  for(var i=0;i<3;i++){
    coordname.push([i*70+5,j*74+55])
  }
}

// COORDONNEE POUR LE Prix

for(var j = 0;j<4;j++){
  for(var i=0;i<3;i++){
    coordprix.push([i*70+30,j*74+65])
  }
}

// COORDONNEE POUR Contour

for(var j = 0;j<4;j++){
  for(var i=0;i<3;i++){
    coordrect.push([i*70+2,j*74+2])
  }
}

// COORDONNEE POUR LE noInscrit

for(var j = 0;j<4;j++){
  for(var i=0;i<3;i++){
    coordno.push([i*70+5,j*74+65])
  }
}





function makePDF(){
  index = 0;

    const doc = new jsPDF();
    articlesToPrint.forEach(element =>{
      if(index>11){
        index = 0
        doc.addPage()
      }
      var qrco = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=';
      qrco += element.id
      doc.addImage(qrco, 'png', coordqr[index][0], coordqr[index][1], 45, 45);
      doc.setFontSize(12)
      doc.text(element.name,coordname[index][0],coordname[index][1])
      doc.setFontSize(30)
      doc.text(element.prix+"€",coordprix[index][0],coordprix[index][1])
      doc.setFontSize(15)
      doc.text(element.codeVendeur,coordno[index][0],coordno[index][1])
      doc.roundedRect(coordrect[index][0],coordrect[index][1],55,70,5,5)
      index+=1;
      
    });
    doc.save(nbToPrint+"etiquettes.pdf")



  
}


// - - - - - - - Fin PDF - - - - - - - - - - -


</script>


<main>
  <div class="cache"></div>
    <Header>
      <div on:click={logout} class="elm">Déconnexion</div>
      <div class="elm" on:click={goListe}>Ma liste 📃</div>
      <div class="elm" on:click={goRdv}>RDV ⏰</div>
      {#if is_Admin}
      <div class="elm" on:click={goJouets}>Articles 🧸</div>
      <div class="elm" on:click={goClients}>Vendeurs 👱‍♂️</div>
      <div class="elm" on:click={goPanier}>Panier 🛒</div>
        {/if}
      </Header>
        <p class="filtre">
          <select name="filtre" id="id_filtre" bind:value={mode}>
            <option value="">--Mode de sélection--</option>
            <option value="tri">Trier</option>
            <option value="filter">Filtrer</option>
          </select>
          <button on:click={resetPrinter}>Reset 🖨️</button>
          <button class="edit" on:click={toggleEdit}>Mode édition</button>
          {#if mode != ''}
          
          {#if mode == 'tri'}
          <span>Trier par : </span>
          <select name="filtre" id="id_filtre" bind:value={filtre}>
            <option value="categorie">Catégorie</option>
            <option value="sub_categorie">Sous catégorie</option>
            <option value="owner_name">Propriétaire</option>
            <option value="prix">Prix</option>
            <option value="creationDate">Date de création</option>
          </select>
          <button on:click={()=>{getJouets(filtre)}}>Trier</button>
          {:else}
          <div style="padding:8px;display: flex; flex-direction:column;border-radius:10px;border:1px solid white">
          <span>Filtrer par code vendeur </span>
          <input type="text" bind:value={codeVendeur} placeholder='Code Vendeur'>
          <button on:click={()=>{getJouetsUser(codeVendeur)}}>Filtrer</button>
          <span>Filtrer par catégorie</span>
          <select name="jouet" id="categorie" bind:value={categorieFilter}>
            <option value="ACTIVITES MANUELLES">Activites Manuelles</option>
            <option value="AUDIO / VIDEO">Audio / Video</option>
            <option value="JEUX DE SOCIETE">Jeux De Societe</option>
            <option value="JEUX EDUCATIF">Jeux Educatif</option>
            <option value="JEUX INTERACTIF">Jeux Interactif</option>
            <option value="JEUX PLEIN AIR">Jeux Plein Air</option>
            <option value="JEUX D’IMITATION">Jeux D’Imitation</option>
            <option value="JOUET 1ER AGE">Jouet 1Er Age</option>
            <option value="JOUET EN BOIS">Jouet En Bois</option>
            <option value="LECTURE">Lecture</option>
            <option value="PUZZLE">Puzzle</option>
            <option value="UNIVERS BEBE">Univers Bebe</option>
            <option value="UNIVERS BEBE NUIT">Univers Bebe Nuit</option>
            <option value="UNIVERS BEBE REPAS">Univers Bebe Repas</option>
            <option value="UNIVERS FILLE">Univers Fille</option>
            <option value="UNIVERS GARCON">Univers Garcon</option>
            </select>
            <button on:click={getJouetsCategorie}>Filtrer</button>
          </div>
          {/if}
          {/if}
          
          
          
        </p>
      <div class="container">
        {#if req}
        {#if !editMode}
        {#each listJouets as jouet}
        <CardJouet showVendu={true} {jouet} on:print={addToPrinter} proprio={true}></CardJouet>
        {/each}
        {:else}
        {#each listJouets as jouet}
        <CardModif on:remove={removeJouet} {jouet}></CardModif>
        {/each}
        {/if}
        {/if}
      </div>
      {#if listJouets.length}
      <button class="print" on:click={makePDF}>Imprimer sélectionné ({nbToPrint})</button>
      {/if}
     
</main>

<style>
main{
    width: 100vw;
    min-height: 100vh;
    background-color: #262626;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
  }
  .elm{ 
        color: white;
        margin-right: 20px;
        cursor: pointer;
        font-weight: 700;
    }

    .elm:hover{
        color: #507DBC ;
        text-decoration: none;
    }
    .cache{
      width: 100vw;
      min-height: 15vh;
    }
    .container{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .edit{
      font-size: 1.4rem;
      background-color: #af1d2a;
      border-radius: 15px;
      border: none;
      color: honeydew;
      transition: .25s ease-in-out;
    }

    .print{
      position: fixed;
      bottom : 3vh;
      right: 3vw;
        cursor: pointer;
        width: fit-content;
        height: fit-content;
        border-radius: 15px;
        color: white;
        font-size: 1.2rem;
        margin: 15px;
        font-weight: 400;
        padding: 15px;
        animation: glow 3s ease-in infinite;
        box-shadow: 0px 0px 30px -10px #7A9CCD;
        transition: ease-in-out .25s;
        user-select: none;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        text-align: center;
        border: none;
    }

    @keyframes glow {
  0% {
    background: #507DBC;
  }
  25% {
    background: #6785af;
  }
  100% {
    background: #507DBC;
  }
}

</style>